import DataTable from 'react-data-table-component';
import { Link, useNavigate } from 'react-router-dom';
import {
   useGetProvidersQuery,
   useDeleteProviderMutation,
   useGetProviderListingPaginationQuery,
} from '../../Redux/Service/ProviderApi';
import { Dropmenu } from '../../Components';
import StyledDashboardLayout from '../style';
import { API_URL } from '../../Config';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useRef, useState } from 'react';
import { Grid } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useModuleHasPermissions } from '../../hooks/useModulePermissions';

const LOGO_BASE_URL = API_URL.replace('/api/v1/', '');

function ServiceProviderList() {
   const [search, setSearch] = useState('');
   const [page, setPage] = useState(1);
   const [perPage, setPerPage] = useState(10);

   const MySwal = withReactContent(Swal);
   const navigate = useNavigate();
   const { data, isFetching } = useGetProviderListingPaginationQuery(
      { search, page, limit: perPage },
      { refetchOnFocus: true, refetchOnMountOrArgChange: true },
   );
   const [deleteProvider] = useDeleteProviderMutation();
   const timerRef = useRef();
   const hasPermissions = useModuleHasPermissions('service_provider');

   const providers = data?.data || [];
   const totalRows = data?.totalCount || 0;

   const handleDelete = async (id) => {
      const result = await MySwal.fire({
         title: 'Are you sure?',
         text: 'Are you sure you want to delete this service provider?',
         icon: 'warning',
         showCancelButton: true,
         confirmButtonText: 'Yes, delete it!',
         cancelButtonText: 'Cancel',
      });

      if (!result.isConfirmed) return;

      try {
         const res = await deleteProvider(id);
         if (res?.error) {
            await MySwal.fire('Denied', res.error?.data?.message || 'Delete failed', 'error');
         } else {
            await MySwal.fire('Deleted!', 'Service provider deleted successfully', 'success');
         }
      } catch (err) {
         await MySwal.fire('Denied!', err?.message || 'Delete failed', 'error');
      }
   };

   const hanldeFilter = (e) => {
      if (timerRef.current) {
         clearTimeout(timerRef.current);
      }
      const val = e.target?.value?.trim();
      timerRef.current = setTimeout(() => {
         setSearch(val);
         setPage(1); // jump back to page 1 whenever the search term changes
      }, 500);
   };

   const handlePageChange = (newPage) => {
      setPage(newPage);
   };

   const handlePerRowsChange = (newPerPage, newPage) => {
      setPerPage(newPerPage);
      setPage(newPage);
   };

   const columns = [
      { name: 'SL No', cell: (_, i) => i + 1 },
      {
         name: 'Logo',
         cell: (row) =>
            row.logo ? (
               <div
                  style={{
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     height: '100%',
                     minHeight: '60px',
                  }}
               >
                  <img
                     src={`${LOGO_BASE_URL}${row.logo}`}
                     alt={row.name}
                     style={{
                        width: 56,
                        height: 56,
                        objectFit: 'contain',
                        borderRadius: 6,
                     }}
                  />
               </div>
            ) : (
               <div
                  style={{
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     height: '100%',
                     minHeight: '60px',
                  }}
               >
                  <span style={{ color: '#aaa' }}>—</span>
               </div>
            ),
      },
      {
         name: 'Name',
         selector: (r) => r.name,
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.name}</div>
         ),
      },
      {
         name: 'Email',
         selector: (r) => r.email,
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.email}</div>
         ),
      },
      {
         name: 'Phone',
         selector: (r) => r.phoneNo,
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.phoneNo}</div>
         ),
      },
      { name: 'Status', selector: (r) => (r.status ? 'Active' : 'Inactive') },
      {
         name: 'Action',
         cell: (row) => (
            <Dropmenu
               handleEdit={() => navigate(`/service-providers/update/${row.id}`)}
               handleDelete={() => handleDelete(row.id)}
               canEdit={hasPermissions?.canUpdate}
               canDelete={hasPermissions?.canDelete}
            />
         ),
      },
   ];

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header">
               <div className="container-fluid">
                  <div className="d-flex justify-content-between mb-2">
                     <div className="pageTitle">
                        <h1>Service Providers</h1>
                     </div>
                     {hasPermissions?.canAdd && (
                        <div className="btnWrap">
                           <Link
                              to="/service-providers/create"
                              className="btn addBtn"
                              style={{ padding: 'inherit' }}
                           >
                              <PersonAddAlt1Icon /> Add Provider
                           </Link>
                        </div>
                     )}
                  </div>
               </div>
            </div>
            {/* <div className="content-header">
               <h1>Service Providers</h1>
               <input
                  type="text"
                  placeholder="Search by name, opportunities,estimates names..."
                  onChange={(e) => hanldeFilter(e)}
                  style={{ width: '360px', marginLeft: 'auto', marginRight: '25px', borderRadius: '30px', border: '1px solid #9f9f9f', padding: '0 20px', fontSize: '13px' }}
               />
               <div className="btnWrap">
                  <Link
                     to="/service-providers/create"
                     className="btn addBtn"
                     style={{ padding: 'inherit' }}
                  >
                     <PersonAddAlt1Icon style={{ marginRight: 6 }} /> Add Provider
                  </Link>
               </div>
            </div> */}
            <div className="card m-3 customCard">
               <Grid container spacing={2}>
                  <Grid item md={6} xs={12}></Grid>
                  <Grid item md={6} xs={12} display="flex" justifyContent="flex-end">
                     <div style={{ position: 'relative', width: '300px', margin: '10px 0' }}>
                        <Search
                           size={16}
                           color="#9f9f9f"
                           style={{
                              position: 'absolute',
                              top: '50%',
                              left: '14px',
                              transform: 'translateY(-50%)',
                              pointerEvents: 'none',
                           }}
                        />
                        <input
                           type="text"
                           placeholder="Search by name, opportunities, estimates names..."
                           onChange={(e) => hanldeFilter(e)}
                           style={{
                              width: '100%',
                              borderRadius: '30px',
                              border: '1px solid #e0e0e0',
                              padding: '10px 16px 10px 40px',
                              fontSize: '13px',
                              outline: 'none',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                              transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                           }}
                           onFocus={(e) => {
                              e.target.style.borderColor = '#7c7c7c';
                              e.target.style.boxShadow = '0 0 0 3px rgba(0,0,0,0.05)';
                           }}
                           onBlur={(e) => {
                              e.target.style.borderColor = '#e0e0e0';
                              e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)';
                           }}
                        />
                     </div>
                  </Grid>
               </Grid>
               <DataTable
                  columns={columns}
                  data={providers.map((p) => ({
                     ...p,
                     logo: p.logo,
                  }))}
                  progressPending={isFetching}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={page}
                  paginationPerPage={perPage}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerRowsChange}
               />
            </div>
         </div>
      </StyledDashboardLayout>
   );
}

export default ServiceProviderList;
